import { colors } from "../../styles/style";

const styleScreenHeader = {
  headerContainer: {
    backgroundColor: colors.BLUE_COLOR,
    width: "100%",
    height: 45,
    marginBottom: "1.5%",
    borderRadius: "0 0 25px 25px",
    paddingTop: 5,
    paddingLeft: "2.5%",
  },
  buttonLogout: {
    border: 0,
    backgroundColor: colors.BLUE_COLOR,
    color: colors.WHITE_COLOR,
  },
  circleUser: {
    height: 30,
    width: 30,
    borderRadius: 50,
    backgroundColor: colors.GRAY_3_COLOR,
  },
};

export { styleScreenHeader };
